export default function SUMIFS() {
  return (
    <div className="p-4">
      <h1>SUMIFS</h1>
    </div>
  );
}
